import { render, staticRenderFns } from "./Chess.vue?vue&type=template&id=84c66c4c&scoped=true"
import script from "./Chess.vue?vue&type=script&lang=js"
export * from "./Chess.vue?vue&type=script&lang=js"
import style0 from "./Chess.vue?vue&type=style&index=0&id=84c66c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c66c4c",
  null
  
)

export default component.exports